module.exports = __webpack_public_path__ + "static/media/Christian_Education_desc.520dab82.png";